import Jobs from '@/components/job/job-list';
import JobUpdate from '@/components/job/job-update';
import JobSchedule from '@/components/job/job-schedule';

import QuoteUpdate from '@/components/quote/quote-update';
import QuoteIFrame from '@/components/quote/quote-iframe';

const routes = [
	{
		path: '/jobs',
		name: 'jobs',
		component: Jobs,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{ text: 'Jobs' }
			],
			requiresAuth: true
		}
	},
	{
		path: '/jobs/schedule',
		name: 'jobschedule',
		component: JobSchedule,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{
					text: 'Jobs',
					to: { name: 'jobs' }
				},
				{ text: 'Schedule' }
			],
			requiresAuth: true
		}
	},
	{
		path: '/jobs/:id',
		name: 'jobupdate',
		component: JobUpdate,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{
					text: 'Jobs',
					href: 'javascript:history.back()',
				},
				{ text: '' }
			],
			requiresAuth: true
		},

	},

	{
		path: '/jobs/:id/:quote',
		name: 'quoteupdate',
		component: QuoteUpdate,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{
					text: 'Jobs',
					href: 'javascript:history.back()',
				},
				{
					text: '',
					to: { name: 'jobupdate' }
				},
				{ text: 'Quote' }
			],

			requiresAuth: true
		}
	},

	{
		path: '/quote/:id',
		name: 'quoteview',
		component: QuoteIFrame ,
		meta: {
			layout: 'public',
		}
	},
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/job/routes/index.js